import axios from '../../plugins/axios.js';

export default{
  async getHolidayScheduleSummary() {
    return await axios.get('/api/Holiday');
  },
  async deleteHolidaySchedule(holidayValues) {
    return await axios.post('/api/Holiday/DeleteHoliday', holidayValues);
  },
  async saveHolidaySchedule(holidayScheduleData) {
    return await axios.post('/api/Holiday',holidayScheduleData);
  },
  async getHolidayID(holidayId){
    return await axios.get(`/api/Holiday/${holidayId}`)
  }
}